import { Builder } from "@olga-food/schemas/lib/classes/schemas/catalog/Builder";
import { Currency } from "shared/utils/Currency";

export class CatalogHelpers {
  static executeOnSchema(item, callback) {
    for (let field of ["items", "extra_ingredients", "sizes"]) {
      if (item[field] && item[field].length > 0) {
        for (let children of item[field]) {
          CatalogHelpers.executeOnSchema(children, callback);
          callback(children, item, field);
        }
      }
    }
  }

  static calculateSelectedItemPrice(item) {
    if (!item?.type) return 0;

    if (item.type !== "pizza") {
      const itemCopy = JSON.parse(JSON.stringify(item));

      const preparedItem = CatalogHelpers.clearUnselectedItems(itemCopy);
      const mountedItem = Builder.mountSchema(preparedItem);

      return +mountedItem.getPrice().toFixed(2);
    } else {
      const pizza = Builder.mountSchema(JSON.parse(JSON.stringify(item)));
      return pizza.getPrice();
    }
  }

  static clearUnselectedItems(item) {
    const props = ["items", "sizes", "extra_ingredients", "doughs", "edges"];
    for (const key of props) {
      const hasQuestions = (item?.items || []).some(
        (children) => children.type === "question",
      );
      if (
        key === "items" &&
        item?.type === "option" &&
        !item?.quantity &&
        hasQuestions
      ) {
        item.selected = false;
        item.items = [];
      }

      if (item[key] && item[key].length > 0) {
        for (const subItemIndex in item[key]) {
          item[key][subItemIndex] = CatalogHelpers.clearUnselectedItems(
            item[key][subItemIndex],
          );
        }

        item[key] = item[key].filter((i) => i.selected !== false);
        if (item[key].length > 0) {
          item.selected = true;
        }
      }
    }
    return item;
  }

  static isPromotionalPrice(product) {
    if (!product?.sizes || product?.sizes?.length <= 0) return false;

    return !!product.sizes.find((size) => size.promo_price === true);
  }

  static mountPrice(item) {
    if (item.price > 0) {
      return Currency.formatCurrency(Number(item.price));
    }

    if (item.price >= 0 && item.sizes.length === 0) {
      return Currency.formatCurrency(Number(item.price));
    }

    if (item.type == "pizza" && !item.highlight) {
      const flavorPriceArray = [];
      const doughPriceArray = [];
      for (const dough of item.doughs) {
        doughPriceArray.push(...(dough.sizes.map((s) => s.price) || []));
      }
      //Buscar dentre os sabores os menor preço
      for (const flavor of item.items) {
        flavorPriceArray.push(...(flavor.sizes.map((s) => s.price) || []));
      }

      const minDoughPrice =
        doughPriceArray.length > 0 ? Math.min(...doughPriceArray) : 0;
      const minFlavorPrice =
        flavorPriceArray.length > 0 ? Math.min(...flavorPriceArray) : 0;

      return Currency.formatCurrency(minDoughPrice + minFlavorPrice);
    }

    if (item.sizes.length > 0) {
      const minValue = Math.min(
        ...((item.sizes || []).map((s) => s.price || 0) || [0]),
      );

      const questions = item?.items || [];

      const minPricesSum = questions
        .filter(
          (question) =>
            !question.price_method || question?.price_method === "SUM",
        )
        .map((question) => {
          const options = question?.items || [];
          const minOptionPrice =
            options.length > 0
              ? Math.min(
                  ...(options.map(
                    (options) => options.price * question.min,
                  ) || [0]),
                )
              : 0;

          return minOptionPrice;
        })
        .reduce((total, optionPrice) => total + optionPrice, 0);

      const minPricesMax = questions
        .filter((question) => question?.price_method === "MAX" && question.min)
        .map((question) => {
          const options = question?.items || [];

          const minPrice = options.reduce((minPrice, option) => {
            return minPrice === null
              ? +option.price
              : Math.min(minPrice, +option.price);
          }, null);

          return minPrice;
        })
        .reduce((maxPrice, minQuestionPrice) => {
          return maxPrice === null
            ? +minQuestionPrice
            : Math.max(maxPrice, +minQuestionPrice);
        }, null);

      return Currency.formatCurrency(
        Number(minValue + minPricesSum + minPricesMax),
      );
    }
  }

  static mountOldPrice(item) {
    const price = item.originalPrice || item.old_price;

    if (price > 0) {
      return Currency.formatCurrency(Number(price));
    }

    if (price >= 0 && item.sizes.length === 0) {
      return Currency.formatCurrency(Number(price));
    }

    if (item.type == "pizza" && !item.highlight) {
      const flavorPriceArray = [];
      const doughPriceArray = [];
      for (const dough of item.doughs) {
        doughPriceArray.push(
          ...(dough.sizes.map((s) => s.originalPrice || s.old_price) || []),
        );
      }
      //Buscar dentre os sabores os menor preço
      for (const flavor of item.items) {
        flavorPriceArray.push(
          ...(flavor.sizes.map((s) => s.originalPrice || s.old_price) || []),
        );
      }

      const minDoughPrice =
        doughPriceArray.length > 0 ? Math.min(...doughPriceArray) : 0;
      const minFlavorPrice =
        flavorPriceArray.length > 0 ? Math.min(...flavorPriceArray) : 0;

      return Currency.formatCurrency(minDoughPrice + minFlavorPrice);
    }

    if (item.sizes.length > 0) {
      const minValue = Math.min(
        ...((item.sizes || []).map(
          (s) => s.originalPrice || s.old_price || 0,
        ) || [0]),
      );

      const questions = item?.items || [];

      const minPricesSum = questions
        .filter(
          (question) =>
            !question.price_method || question?.price_method === "SUM",
        )
        .map((question) => {
          const options = question?.items || [];

          const minOptionPrice =
            options.length > 0
              ? Math.min(
                  ...(options.map(
                    (options) => options.price * question.min,
                  ) || [0]),
                )
              : 0;

          return minOptionPrice;
        })
        .reduce((total, optionPrice) => total + optionPrice, 0);

      const minPricesMax = questions
        .filter((question) => question?.price_method === "MAX" && question.min)
        .map((question) => {
          const options = question?.items || [];

          const minPrice = options.reduce((minPrice, option) => {
            return minPrice === null
              ? +option.price
              : Math.min(minPrice, +option.price);
          }, null);

          return minPrice;
        })
        .reduce((maxPrice, minQuestionPrice) => {
          return maxPrice === null
            ? +minQuestionPrice
            : Math.max(maxPrice, +minQuestionPrice);
        }, null);

      return Currency.formatCurrency(
        Number(minValue + minPricesSum + minPricesMax),
      );
    }
  }

  static getProductsBySkus(catalog, skus = []) {
    let productsBySku = [];
    Builder.executeOnSchema(catalog, (children) => {
      if (["step", "question", "option"].includes(children.type)) {
        const size = (children?.sizes || []).find((size) => size.sku) || {};
        const sku = size?.sku || children?.sku;

        if (sku && skus.includes(String(sku))) {
          productsBySku.push(sku);
        }
      }
    });

    return productsBySku;
  }

  static getFirstProductIdOnSkuList(cartItems, skus = []) {
    for (let i = 0; i < cartItems.length; i++) {
      const item = Builder.mountSchema(
        JSON.parse(JSON.stringify(cartItems[i])),
      );

      const itemSku = item.sku;
      const itemId = item.id;
      if (itemId && itemSku && skus.includes(itemSku)) {
        return itemId;
      }

      const size = (item?.sizes || []).find((size) => size.sku) || {};
      const sizeSku = size?.sku;

      if (sizeSku && skus.includes(sizeSku)) {
        return size.parent || size.id;
      }

      let found = null;
      Builder.executeOnSchema(item, (children) => {
        if (["step", "question", "option"].includes(children.type)) {
          const childrenSku = children?.sku;

          const size = (children?.sizes || []).find((size) => size.sku) || {};
          const sizeSku = size?.sku;

          if (childrenSku && skus.includes(childrenSku)) {
            found = children.id || itemId;
          } else if (sizeSku && skus.includes(sizeSku)) {
            found = size.parent || itemId;
          }
        }
      });
      if (found) {
        return found;
      }
    }
    return null;
  }

  static getFirstItemSkuOnSkuList(cartItems, skus = []) {
    for (let i = 0; i < cartItems.length; i++) {
      const item = Builder.mountSchema(
        JSON.parse(JSON.stringify(cartItems[i])),
      );

      const itemSku = item.sku;
      if (itemSku && item.selected && item.quantity && skus.includes(itemSku)) {
        return itemSku;
      }

      const size = (item?.sizes || []).find((size) => size.sku) || {};
      const sizeSku = size?.sku;

      const found = new Set([]);

      if (sizeSku && size.selected && size.quantity && skus.includes(sizeSku)) {
        found.add(sizeSku);
      }

      Builder.executeOnSchema(item, (children) => {
        if (["step", "question", "option"].includes(children.type)) {
          const childrenSku = children?.sku;

          const size = (item?.sizes || []).find((size) => size.sku) || {};
          const sizeSku = size?.sku;

          if (
            childrenSku &&
            children.selected &&
            children.quantity &&
            skus.includes(childrenSku)
          ) {
            found.add(childrenSku);
          } else if (
            sizeSku &&
            (size.selected || size.quantity) &&
            skus.includes(sizeSku)
          ) {
            found.add(sizeSku);
          }
        }
      });

      if (found.size > 0) return [...found];
    }
    return null;
  }

  static cartItemHasId(cartItem, id) {
    const item = Builder.mountSchema(JSON.parse(JSON.stringify(cartItem)));

    const itemId = item.sku;
    if (itemId && id.includes(itemId) && item.selected && item.quantity) {
      return true;
    }

    const itemSizes = item?.sizes || [];
    const foundSize = itemSizes.find(
      (size) => id.includes(size.sku) && size.selected && size.quantity,
    );
    if (itemSizes?.length && foundSize) {
      return true;
    }

    let found = false;
    Builder.executeOnSchema(item, (children) => {
      if (["step", "question", "option"].includes(children.type)) {
        if (
          id.includes(children?.sku) &&
          children.selected &&
          children.quantity
        ) {
          found = true;
        }

        const childrenSizes = item?.sizes || [];
        if (
          childrenSizes?.length &&
          childrenSizes.find(
            (size) => id.includes(size.sku) && size.selected && size.quantity,
          )
        ) {
          found = true;
        }
      }
    });
    return found;
  }
}
